import { useState } from 'react';
import { usePostMessage } from '../../context/messageContext';
import { Button, ButtonSet } from '../../ui';

// [Clear Stimulus] / [Next Stimulus] under the Stroke Suite matrix.
const StimulusControls = ({ testProgressData, canStartTest }) => {
  const [nextStimulusButtonDisabled, setNextStimulusButtonDisabled] = useState(true);
  const postMessage = usePostMessage();

  return (
    <ButtonSet gap={12} justify='center'>
      <Button
        variant='destructive'
        size='lg'
        disabled={canStartTest || !testProgressData.currentLandoltCQuadrant}
        onClick={() => {
          setNextStimulusButtonDisabled(false);
          postMessage({ type: 'clearStimulus' });
        }}
      >
        Clear Stimulus
      </Button>
      <Button
        size='lg'
        disabled={nextStimulusButtonDisabled || testProgressData.testEnded}
        onClick={() => {
          setNextStimulusButtonDisabled(true);
          postMessage({ type: 'nextStimulus' });
        }}
      >
        Next Stimulus
      </Button>
    </ButtonSet>
  );
};

export default StimulusControls;
